import { DefaultTheme } from 'styled-components';

export default {} as DefaultTheme;
